import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2294_9983)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 10.7405V15.3878H18.9582C18.6746 16.8823 17.8236 18.1478 16.5472 18.9987L20.4417 22.0205C22.7108 19.9261 24.0199 16.8497 24.0199 13.1951C24.0199 12.3442 23.9436 11.526 23.8017 10.7406L12.5 10.7405Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.77461 15.2064L4.89625 15.8787L1.78711 18.3005C3.76165 22.2168 7.80862 24.9223 12.4995 24.9223C15.7394 24.9223 18.4557 23.8532 20.4412 22.0206L16.5467 18.9987C15.4776 19.7187 14.114 20.1551 12.4995 20.1551C9.37951 20.1551 6.72868 18.0497 5.77952 15.2133L5.77461 15.2064Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.78718 7.54419C0.969042 9.15867 0.5 10.9805 0.5 12.9223C0.5 14.8641 0.969042 16.6859 1.78718 18.3004C1.78718 18.3112 5.77997 15.2022 5.77997 15.2022C5.53998 14.4822 5.39812 13.7186 5.39812 12.9222C5.39812 12.1257 5.53998 11.3621 5.77997 10.6421L1.78718 7.54419Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.4997 5.70054C14.267 5.70054 15.8379 6.31143 17.0925 7.48963L20.5288 4.05331C18.4452 2.11153 15.7398 0.922363 12.4997 0.922363C7.80887 0.922363 3.76165 3.6169 1.78711 7.54419L5.77978 10.6424C6.72882 7.80598 9.37976 5.70054 12.4997 5.70054Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2294_9983",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0.5 0.922363)"
		})
	}) })]
});
export default SvgGoogle;
